<template>
  <div class="create-account">
    <v-row>
      <v-col sm="4">
        <label>{{ $t("_REGISTER.USERNAME") }} *</label>
        <input-text
          maxlength="50"
          :regex="REGEX_USERNAME"
          :placeholder="$t('_REGISTER.CREATE_NEW_ACCOUNT_NAME')"
          :model.sync="username"
          :error.sync="errors.username.error"
          :errorMessage="errors.username.message"
        >
          <div class="icon" slot="icon">
            <font-awesome-icon icon="check" v-if="username && !errors.username.error" />
            <font-awesome-icon icon="exclamation-circle" v-if="errors.username.error" />
          </div>
        </input-text>
      </v-col>
      <v-col sm="4">
        <label>{{ $t("_REGISTER.CREATE_PASSWORD") }} *</label>
        <input-text
          type="password"
          classList="password"
          :placeholder="$t('_REGISTER.PASSWORD')"
          :isRealtimeValidate="true"
          :model.sync="password"
          :error.sync="errors.password.error"
          :errorMessage="errors.password.message"
        />
      </v-col>
      <v-col sm="4">
        <label>{{ $t("_REGISTER.RETYPE_PASSWORD") }} *</label>
        <input-text
          type="password"
          classList="retypepassword"
          :placeholder="$t('_REGISTER.RETYPE_PASSWORD')"
          :isRealtimeValidate="true"
          :model.sync="retypepassword"
          :error.sync="errors.retypepassword.error"
          :errorMessage="errors.retypepassword.message"
        >
          <div class="icon" slot="icon">
            <font-awesome-icon
              icon="check"
              v-if="
                retypepassword &&
                  retypepassword == password &&
                  !errors.retypepassword.error
              "
            />
            <font-awesome-icon icon="exclamation-circle" v-if="errors.retypepassword.error" />
          </div>
        </input-text>
      </v-col>
    </v-row>
    <div class="terms-of-use">
      <p>{{ $t("_REGISTER.VALID_USERNAME_MESSAGE") }}</p>
      <p>
        {{ $t("_REGISTER.BY_CLICKING_REGISTER") }}
        <a
          href="#"
        >{{ $t("_REGISTER.TERM_AND_CONDITIONS") }}</a> &
        <a href="#">{{ $t("_REGISTER.PRIVACY_POLICY") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import { registerService } from "@/_services/register.service.js";
import { _validateForm, _alert } from "@/_helpers/function.js";
import { CA_ERROR } from "@/_helpers/config.js";
import { REGEX_USERNAME } from "@/_helpers/constant.js";
export default {
  name: "CreateAcoount",
  components: {
    "input-text": Input
  },
  props: {
    isAvailableRegis: Boolean
  },
  data() {
    return {
      username: null,
      password: null,
      retypepassword: null,
      errors: CA_ERROR
    };
  },
  created() {
    if (this.$store.state.modulesRegister.createAccount.length <= 0)
      return false;
    this.data = this.$store.state.modulesRegister.createAccount;
  },
  watch: {
    errors: {
      handler(value) {
        this.readyToRegister();
      },
      deep: true
    },
    username(value) {
      this.errors.username.error = false;
      this.readyToRegister();
    },
    retypepassword(value) {
      if (value) {
        if (value.length < 8) {
          this.errors.retypepassword.error = true;
          this.errors.retypepassword.message = this.$t(
            "_REGISTER.PASSWORD_NOT_LESS_THAN"
          );
        } else if (this.password != value) {
          this.errors.retypepassword.error = true;
          this.errors.retypepassword.message = this.$t(
            "_REGISTER.PASSWORD_NOT_MATCH"
          );
        } else {
          this.errors.retypepassword.error = false;
          this.errors.password.message = "";
          this.errors.retypepassword.message = "";
        }
      } else {
        this.errors.retypepassword.error = false;
        this.errors.retypepassword.message = "";
      }
      this.readyToRegister();
    },
    password(value) {
      if (value) {
        if (value.length < 8) {
          this.errors.password.error = true;
          this.errors.password.message = this.$t(
            "_REGISTER.PASSWORD_NOT_LESS_THAN"
          );
        } else {
          this.errors.password.error = false;
          this.errors.password.message = "";
          document.querySelector("input.password").classList.remove("invalid");
        }
        if (this.retypepassword && this.retypepassword != value) {
          this.errors.retypepassword.error = true;
          this.errors.retypepassword.message = this.$t(
            "_REGISTER.PASSWORD_NOT_MATCH"
          );
        } else if (this.retypepassword.length >= 8) {
          this.errors.retypepassword.error = false;
          this.errors.retypepassword.message = "";
        }
      } else {
        this.errors.password.error = false;
        this.errors.password.message = "";
      }
      this.readyToRegister();
    }
  },
  computed: {
    REGEX_USERNAME() {
      return REGEX_USERNAME;
    }
  },
  methods: {
    validate(data) {
      let { isValid, error } = _validateForm(data, this.errors);
      if (this.password.length < 8 || this.retypepassword.length < 8) {
        _alert(null, this.$t("_REGISTER.PASSWORD_NOT_LESS_THAN"), false);
      }
      this.errors = error;
      if (!isValid) {
        this.$emit("update:isAvailableRegis", false);

        return false;
      }
      if (this.password != this.retypepassword) {
        this.errors.retypepassword.error = true;
        this.errors.retypepassword.message = this.$t(
          "_REGISTER.PASSWORD_NOT_MATCH"
        );
        _alert(null, this.$t("_REGISTER.PASSWORD_NOT_MATCH"), false);
        return false;
      }
      this.errors.retypepassword.error = false;
      this.$emit("update:isAvailableRegis", false);
      return true;
    },
    save() {
      let tempData = {
        username: this.username,
        password: this.password,
        lang: this.$i18n.locale,
        retypepassword: this.retypepassword
      };
      let isValid = this.validate(tempData);
      if (!isValid) {
        return false;
      }
      this.$store.commit("storeAccountData", tempData);
      this.$emit("update:isAvailableRegis", true);
      this.registerAccount();
    },
    registerAccount() {
      let personDetail = this.$store.state.modulesRegister.personDetail;
      let account = this.$store.state.modulesRegister.createAccount;
      let hotelDetail = this.$store.state.modulesRegister.hotelDetail;
      let utm = {
        utmSource: this.$cookies.get('utm_source'),
        utmMedium: this.$cookies.get('utm_medium'),
        utmCampaign: this.$cookies.get('utm_campaign'),
        utmContent: this.$cookies.get('utm_content'),
        utmTerm: this.$cookies.get('utm_term'),
      };
      let concat = Object.assign({}, account, personDetail, hotelDetail, utm);
      let data = new Object();
      let exclude = ["retypepassword", "hotelCityId", "hotelCountryId"];
      Object.keys(concat).forEach(x => {
        if (!exclude.includes(x)) data[x] = concat[x];
      });
      let vm = this;
      registerService.register(data).then(res => {
        if (res.responseCode == 0) {
          _alert(res, this.$t("REGISTER_SUCCESS"), false);
        }
        if (res.responseCode != 0) {
          _alert(res, this.$t("USER_NAME_OR_EMAIL_IS_EXISTED"), false);
          if (res.data == "USER_IS_EXIST") {
            this.errors.username.error = true;
            this.errors.username.message = this.$t("ACCOUNT_IS_TAKEN");
          }
          return false;
        }
        let username = res.data.username;
        let token = res.data.token;
        localStorage.setItem(
          "justRegistedUser",
          JSON.stringify({ username: username, token: token })
        );
        vm.$emit("validate");
      });
    },
    readyToRegister() {
      let isFillAll = this.username && this.password && this.retypepassword;
      let isValid =
        !this.errors.username.error &&
        !this.errors.password.error &&
        !this.errors.retypepassword.error;
      if (isFillAll && isValid) {
        this.$emit("update:isAvailableRegis", true);
      } else this.$emit("update:isAvailableRegis", false);
    }
  }
};
</script>
